import type { PortalSectionId } from './roles';

const STORAGE_KEY = 'mediclynk-admin-pinned-sections';

export function getPinnedSections(): PortalSectionId[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as PortalSectionId[]) : [];
  } catch {
    return [];
  }
}

function setPinnedSections(ids: PortalSectionId[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // localStorage unavailable (private browsing, quota) — pins just won't persist this session
  }
}

export function togglePinnedSection(id: PortalSectionId): PortalSectionId[] {
  const current = getPinnedSections();
  const next = current.includes(id) ? current.filter((s) => s !== id) : [...current, id];
  setPinnedSections(next);
  return next;
}
